<template>
  <div>
    <div class="title">
      <h1>{{params.name}}</h1>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="text" v-html="params.text"></div>
        <shop_reviews_block :params="params.reviews" v-if="$store.state.global.screenWidth>768"/>
      </div>
      <div class="col-md-6">
        <div class="row mrb" v-if="params.photos.length>0">
          <div class="col-md-6" v-for="photo in params.photos">
            <img class="img" :src="photo">
          </div>
        </div>
        <div class="row" v-if="params.videos.length>0">
          <div class="col-md-6" v-for="video in params.videos">
            <div class="video">
              <iframe width="100%" height="100%" style="min-height: 300px" :src="video"></iframe>
            </div>
          </div>
        </div>
<!--        <div class="mayMap" ref="mayMap" v-if="params.map.show"></div>-->
        <div v-if="params.storeImgMap">
          <img :src="params.storeImgMap" alt="Store map image">
        </div>
        <shop_reviews_block :params="params.reviews" v-if="$store.state.global.screenWidth<768"/>
      </div>
    </div>
  </div>
</template>

<script>
import Shop_reviews_block from "./reviews/shop_reviews_block.vue";

export default {
  name: "shops_detail_block",
  components: {Shop_reviews_block},
  selector: '.shops_detail_block',
  props:{params: Object},
  mounted() {
    // if(this.params.map.show) {
    //   const mapOptions = {
    //     zoom: 14,
    //     center: new google.maps.LatLng(this.params.map.ln, this.params.map.lg)
    //   };
    //   var mapStyleZoomedOut = [
    //     {
    //       elementType: "geometry",
    //       stylers: [
    //         { hue: "#F8CBD8" },
    //         { lightness: 60 },
    //         { saturation: -20 }
    //       ]
    //     },{
    //       elementType: "labels",
    //       stylers: [
    //         { visibility: "on" },
    //         { hue: "#AA8B9E" },
    //         { lightness: 50 },
    //         { saturation: -20 }
    //       ]
    //     },
    //     {
    //       featureType: "road",
    //       elementType: "labels",
    //       stylers: [
    //         { saturation: -60 }
    //       ]
    //     }
    //   ];
    //
    //   var map = new google.maps.Map(this.$refs['mayMap'], mapOptions);
    //   var styledMapOptions = {map: map, name: 'minimial'};
    //   var sMapType = new google.maps.StyledMapType(mapStyleZoomedOut, styledMapOptions);
    //   map.mapTypes.set('minimal', sMapType);
    //   map.setMapTypeId('minimal');
    //   let marker = new google.maps.Marker({
    //     position: new google.maps.LatLng(this.params.map.ln, this.params.map.lg),
    //     map: map,
    //         icon: {
    //       url: 'https://brand.tous.com/storelocator/media/img/shoptype_1.png',
    //           size: new google.maps.Size(23, 40),
    //           origin: new google.maps.Point(0, 0),
    //           anchor: new google.maps.Point(11, 20),
    //     },
    //     animation: google.maps.Animation.DROP,
    //   });
    // }

  }
}
</script>

<style scoped>
.mayMap {
  margin-bottom: 20px;
}
</style>